import React from "react";
import { Grid } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import useStyles from "./styles";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CloseIcon from "@material-ui/icons/Close";
import CancelIcon from "@material-ui/icons/Cancel";
import theme from "theme";

const AlertMessage = props => {
	const classes = useStyles();
	const { isError, message, handleCloseAlert } = props;
	return (
		<Grid classes={{ root: classes.root }}>
			<Grid classes={{ root: classes.rootMessage }}>
				<Alert
					severity="success"
					color="info"
					icon={
						isError ? (
							<CancelIcon classes={{ root: classes.iconError }} />
						) : (
							<CheckCircleIcon
								classes={{ root: classes.iconSuccess }}
							/>
						)
					}
					style={{
						color: isError
							? theme.palette.error.main
							: theme.palette.success.main
					}}
					action={
						<CloseIcon
							onClick={handleCloseAlert}
							style={{
								color: isError
									? theme.palette.error.main
									: theme.palette.success.main
							}}
						/>
					}
					classes={{ root: classes.rootAlert }}
				>
					{message}
				</Alert>
			</Grid>
		</Grid>
	);
};

export default AlertMessage;
